export class ChargeAccountSummaryCardController {
    public static $inject = ['$state'];

    constructor(private $state: ng.ui.IStateService) {
    }

    public navigateToChargeAccount = (chargeAccoundId: string) => {
        this.$state.go('charge-account-summary', { chargeAccountId: chargeAccoundId });

    }
}